module.exports = __webpack_public_path__ + "img/diapositiva-4-2.d433c14f.png";